exports = module.exports = require("../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".test-h-carousel{background-image:radial-gradient(ellipse farthest-corner at 50% 70%,#dee1e2 20%,#edf0f1 30%,#c3c6c7 60%)}.test-h-carousel .h-carousel-item{background:#969896}.test-h-carousel h3{color:#fff;font-size:20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly;height:100%;padding:0;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?minimize!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-538f44e8","scoped":false,"hasInlineConfig":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=1!./node_modules/_vue-markdown-loader@2.4.1@vue-markdown-loader/lib/markdown-compiler.js?raw!./src/docs/carousel.md
// module id = 21O1
// module chunks = 0